<template>
  <v-dialog v-model="config.enabled" :width="config.width" :persistent="config.persistent">
    <v-card class="pt-3 pb-5 pr-6 pl-6 text-center d-flex flex-column flex-gap-3 justify-center align-center">
      <v-img class="mt-5" height="250" width="150" :src="imagePath"></v-img>
      <span
        class="mt-2 font-weight-bold"
        :style="{
          color: customCSS['popUpImage-title-textColor'] || 'primary',
          'font-family': customCSS['popUpImage-title-fontFamily'],
          'font-size': '30px',
        }"
        >{{ config.title }}</span
      >
      <p
        class="mt-1 text-disabled"
        :style="{
          color: customCSS['popUpImage-content-textColor'] || '',
          'font-family': customCSS['popUpImage-content-fontFamily'],
        }"
      >
        {{ config.content }}
      </p>
    </v-card>
  </v-dialog>
</template>

<script>
import * as colors from '@/_core/util/themeUtility';
import commonService from '@/_core/service/commonService';
export default {
  name: 'Image Modal',
  props: {
    config: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      customCSS: '',
      imagePath: '',
    };
  },
  created() {
    this.customCSS = colors.colors;
  },
  async mounted() {
    const response = await commonService.getImageData(
      `assets/images/status_codes/${this.config.status}.png`,
    );

    this.imagePath = 'data:image/png;base64,' + response.image;
  },
};
</script>
